<template>
  <v-ons-page class="l-content l-profilEdit">
    <v-ons-toolbar class="toolbar toolbarWhite">
      <div class="left">
        <v-ons-back-button></v-ons-back-button>
      </div>
      <div class="center">{{ $t("Modifier mon profil") }}</div>
    </v-ons-toolbar>

    <div class="container"> 
      <div v-if="user"> 
        <form>
          <p>
            <label for="firstname">{{ $t("Prénom") }}</label>
            <v-ons-input id="firstname" modifier="material" v-model="user.pro_fName" readonly></v-ons-input>
          </p>
          <p>
            <label for="lastname">{{ $t("Nom") }}</label>
            <v-ons-input id="lastname" modifier="material" v-model="user.pro_lName" readonly></v-ons-input>
          </p>

          <p>
            <label for="email">Email</label>
            <v-ons-input type="email" id="email" modifier="material" v-model="user.pro_email" required></v-ons-input>
          </p>
          <p>
            <label for="password">{{ $t("Mot de passe") }}</label>
            <v-ons-input id="password" type="password" modifier="material" v-model="user.pro_password"></v-ons-input>
          </p>

          <p>
            <label for="nie">{{ $t("NIE") }}</label>
            <v-ons-input id="nie" :placeholder="$t('Numéro d\'identification d\'étranger')" modifier="material" v-model="user.pro_nie"></v-ons-input>
          </p>

          <p>
            <label for="address">{{ $t("Adresse") }}</label>
            <v-ons-input id="address" modifier="material" v-model="user.pro_address"></v-ons-input>
          </p>
          <p>
            <label for="zip">{{ $t("Code postal") }}</label>
            <v-ons-input id="zip" modifier="material" v-model="user.pro_zip"></v-ons-input>
          </p>
          <p>
            <label for="city">{{ $t("Ville") }}</label>
            <v-ons-input id="city" modifier="material" v-model="user.pro_city"></v-ons-input>
          </p>
          <p>
            <label for="country">{{ $t("Pays") }}</label>
            <v-ons-select id="country" modifier="material" v-model="user.pro_fk_country">
              <option v-for="country in countries" :value="country.cty_id">{{ i18n_country(country) }}</option>
            </v-ons-select>
          </p>

          <p>
            <label for="tel">{{ $t("Téléphone") }}</label>
            <v-ons-input id="tel" modifier="material" v-model="user.pro_tel"></v-ons-input>
          </p>
          <p>
            <label for="mobile">{{ $t("Mobile") }}</label>
            <v-ons-input id="mobile" modifier="material" v-model="user.pro_mobile"></v-ons-input>
          </p>

          <v-ons-button @click="save">{{ $t("Enregistrer") }}</v-ons-button>
        </form>
      </div>
    </div>
  </v-ons-page>
</template>

<script>
  import Profile from './Profile.vue';
  
  export default {
    data () {
      return {
        countries: []
      };
    },
    methods: {
      save() {
        var form = this.$el.querySelector('form');
        form.reportValidity();

        if(form.checkValidity()) {
          self = this;
          axios
            .get('/users/save', {
              params: {
                'x-secundo-auth': loggedIn.token,
                'prospect_id': loggedIn.pro_id,
                'user': JSON.stringify(this.user)
              }
            })
            .then(response => {
              this.$ons.notification.toast(self.$i18n.t('Votre profil a bien été enregistré'), {timeout: 2000})
              this.$store.commit('navigator/pop');
            });
        }
      },
      i18n_country(country) {
        var country_name_var = 'cty_name' + this.$i18n.locale.toUpperCase();
        return country[country_name_var] ? country[country_name_var] : country.cty_nameEN;
      }
    },
    created() {
      axios
        .get('/users/get-countries', {
          params: {
            'x-secundo-auth': 'ABC123',
          }
        })
        .then(response => {
          this.countries = response.data;
        });
    }
  };
</script>


// WEBPACK FOOTER //
// ProfileEdit.vue?7d3a6911